<i18n>
{
  "ru":{
    "invoice_search": "Поиск по счетам",
    "notpaid": "Не оплачен",
    "overdue": "Просрочен",
    "due": "Ожидание оплаты",
    "pending": "Оплачен",
    "paid": "Оплачен",
    "authorized": "Авторизован",
    "notpaid_short": "Ожидает оплаты",
    "due_short": "Не оплачен",
    "declined_short": "Отклонён",
    "voided_short": "Сброшен",
    "failed_short": "Ошибка",
    "partial_voided_short": "Частично сброшен",
    "recurrent_short": "Рекуррентный",
    "declined": "Платёж отклонён",
    "refunded": "Отменен",
    "partial_refunded": "Частичная отмена",
    "voided": "Сброшенный после авторизации",
    "failed": "Ошибка в проведении операции",
    "partial_voided": "Частичный сброс",
    "recurrent": "Рекуррентный платеж",
    "oct": "Оплачен",
    "blocked": "Заблокирован",
    "verification": "Верификация"
  },
  "en":{
    "invoice_search": "Search invoices",
    "notpaid": "Not paid",
    "overdue": "Overdue",
    "due": "Pending",
    "pending": "Paid",
    "paid": "Paid",
    "authorized": "Authorized",
    "notpaid_short": "Pending",
    "due_short": "Not paid",
    "declined_short": "Declined",
    "voided_short": "Voided",
    "failed_short": "Failed",
    "partial_voided_short": "Partial Voided",
    "recurrent_short": "Recurrent",
    "declined": "Declined",
    "refunded": "Refunded",
    "partial_refunded": "Partial Refunded",
    "voided": "Voided",
    "failed": "Failed",
    "partial_voided": "Partial Voided",
    "recurrent": "Recurrent",
    "oct": "Paid",
    "blocked": "Blocked",
    "verification": "Verification"
  }
}
</i18n>
<template>
  <div style="margin: auto;max-width: 900px;">
    <invoice-modal
      v-if="showInvoiceModal"
      :visible.sync="showInvoiceModal"
      :callback="invoiceChanged"
    />
    <el-row type="flex" :gutter="20">
      <el-col class="aligner right">
        <!-- <el-button
          round
          plain
          type="info"
          disabled
        >{{$t('excel_export')}}</el-button>-->
        <el-button
          round
          plain
          type="primary"
          v-if="canAddInvoice"
          @click.prevent="newInvoice()"
        >{{ $t('new_invoice') }}</el-button>
      </el-col>
    </el-row>

    <el-row v-if="filter && !hideInvoicesList" :gutter="20" v-loading="loading">
      <el-col :span="24">
        <el-card>
          <h2 class="search--panel-title">{{ $t('invoice_search') }}:</h2>
          <el-form
            class="search_filter"
            :class="filterCollapsed && emptyFilter ? 'collapsed' : ''"
            @submit.native.prevent="loadInvoices"
          >
            <input class="hidden-input" ref="hidden" />
            <el-row :gutter="20">
              <el-col :sm="5" style="position: relative">
                <span class="label">{{ $t('status') }}</span>
                <el-select clearable v-model="filter.order_status" placeholder=" ">
                  <el-option :label="$t('notpaid_short')" value="notpaid"></el-option>
                  <el-option :label="$t('due_short')" value="due"></el-option>
                  <el-option :label="$t('paid')" value="paid"></el-option>
                  <el-option :label="$t('authorized')" value="authorized"></el-option>
                  <el-option :label="$t('partial_refunded')" value="partial_refunded"></el-option>
                  <el-option :label="$t('refunded')" value="refunded"></el-option>
                  <el-option :label="$t('oct')" value="oct"></el-option>
                  <el-option :label="$t('blocked')" value="blocked"></el-option>
                  <el-option :label="$t('verification')" value="verification"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="5">
                <a href="#" class="label" @click.prevent="changeSort('date_orig')">
                  {{ $t('date_orig') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'date_orig' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'date_orig' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>

                <el-date-picker
                  type="date"
                  v-model="filter.search_form_date_orig_date_from"
                  :placeholder="$t('from')"
                  @change="$refs['hidden'].focus()"
                ></el-date-picker>
              </el-col>
              <el-col :sm="5">
                <span class="label">&nbsp;</span>
                <el-date-picker
                  type="date"
                  v-model="filter.search_form_date_orig_date_to"
                  :placeholder="$t('to')"
                  @change="$refs['hidden'].focus()"
                ></el-date-picker>
              </el-col>
              <el-col :sm="5">
                <a href="#" class="label" @click.prevent="changeSort('id')">
                  {{ $t('invoice_id') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'id' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'id' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
                <el-input v-model="filter.search_form_id"></el-input>
              </el-col>
              <el-col :sm="4" style="position: relative">
                <a href="#" class="label" @click.prevent="changeSort('account_id')">
                  {{ $t('account_id') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'account_id' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'account_id' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
                <el-input v-model="filter.search_form_account_id"></el-input>
              </el-col>
              <el-col :sm="6">
                <a href="#" class="label" @click.prevent="changeSort('name')">
                  {{ $t('invoice_name') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'name' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'name' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
                <el-input v-model="filter.search_form_name"></el-input>
              </el-col>
              <el-col :sm="6">
                <a href="#" class="label" @click.prevent="changeSort('po_name')">
                  {{ $t('po_name') }}
                  <i
                    class="filter-icon"
                    :class="{
                      'filter-arrow-down':
                        filter.order_field == 'po_name' &&
                        filter.order_type == 'asc',
                      'filter-arrow-up':
                        filter.order_field == 'po_name' &&
                        filter.order_type == 'desc'
                    }"
                  ></i>
                </a>
                <el-input v-model="filter.search_form_po_name"></el-input>
              </el-col>

              <el-col :sm="6" style="position: relative;" v-if="showQrButton">
                <span class="label">Выставленный через QR</span>
                <el-checkbox size="medium" v-model="filterByQr"></el-checkbox>
              </el-col>
              <el-col :span="6" :xs="24">
                <span class="label">&nbsp;</span>
                <div class>
                  <el-button round type="danger" @click="reset()" size="small">{{ $t('clear') }}</el-button>
                  <el-button
                    round
                    type="primary"
                    native-type="submit"
                    size="small"
                  >{{ $t('search') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <el-row class="aligner">
            <i
              class="filter-collapse-icon"
              :class="{ open: filterCollapsed && emptyFilter }"
              @click="filterCollapsed = !filterCollapsed"
            ></i>
          </el-row>
        </el-card>
      </el-col>

      <el-col v-if="tableData.length" :span="24">
        <el-card v-for="invoice in tableData" :key="invoice.id">
          <div class="list-item-header" @click.prevent="invoice.show = !invoice.show">
            <el-row :gutter="20">
              <el-col :xs="12" :sm="4">
                <div class="list-item-text">
                  {{ $t('date_orig') }}:
                  <span>{{ invoice.date_orig }}</span>
                </div>
                <div class="list-item-text">
                  {{ $t('invoice_id') }}:
                  <span>{{ invoice.id }}</span>
                </div>
                <div class="list-item-text">
                  {{ $t('invoice_name') }}:
                  <span>{{ invoice.name }}</span>
                </div>
              </el-col>
              <el-col :xs="12" :sm="6">
                <div class="list-item-text">
                  {{ $t('po_name') }}:
                  <span>{{ invoice.po_name }}</span>
                </div>
                <div class="list-item-text">
                  {{ $t('buyer') }}:
                  <span>{{ invoice.payer }}</span>
                </div>
                <div class="list-item-text item_invoice_card">
                  {{ $t('payment_method') }}:
                  <span>{{ invoice.transaction_log_reserv3 }}</span>
                </div>
              </el-col>
              <el-col :xs="12" :sm="3">
                <div
                  class="list-item-text card_brand"
                  :class="{
                    visa: invoice.card == 'VISA',
                    mastercard:
                      invoice.card == 'MASTERCARD' || invoice.card == 'MC',
                    belcard: invoice.card == 'БЕЛКАРТ',
                    belqi: invoice.card == 'BELQI WALLET'
                  }"
                ></div>
              </el-col>
              <el-col :xs="12" :sm="6">
                <div class="list-item-text">
                  {{ invoice.currency_id }}
                  <span class="invoice_amount">{{ invoice.total_amt }}</span>
                </div>
                <div class="list-item-text">
                  {{ $t('field_due_date') }}:
                  <span>{{ invoice.due_date }}</span>
                </div>
              </el-col>
              <el-col :xs="12" :sm="5">
                <div
                  class="list-item-text"
                  :class="'invoice_status ' + invoice.billing_status"
                >{{ $t(invoice.billing_status) }}</div>
              </el-col>
            </el-row>
          </div>

          <invoice-details
            v-if="invoice.url_invoice && invoice.show"
            :visible.sync="invoice.show"
            :url="invoice.url_invoice"
            :callback="invoiceChanged"
            :invoicesListUrl="invoicesListUrl"
            :showRemoveButton="showRemoveButton"
          ></invoice-details>
        </el-card>
      </el-col>

      <el-col v-if="tableData.length" :offset="0" :span="24">
        <el-card>
          <el-pagination
            class="aligner right"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next"
            :total="pagination.total"
            @current-change="changePage"
          ></el-pagination>
        </el-card>
      </el-col>
      <el-col :span="24" v-if="!loading && !tableData.length">
        <el-card class="aligner">{{ $t('notfound') }}</el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiRes from '../../core/apiRes'
import InvoiceModal from './InvoiceModal'
import InvoiceDetails from './InvoiceDetails'
import { eventBus } from '../../event-bus'

export default {
  name: 'invoices',
  components: {
    'invoice-details': InvoiceDetails,
    'invoice-modal': InvoiceModal
  },
  data: () => ({
    showInvoiceModal: false,
    filterCollapsed: true,
    canAddInvoice: !!apiRes.addInvoiceUrl,
    filter: null,
    pagination: null,
    invoicesListUrl: null,

    pageLinks: {},
    sortLinks: {},
    tableData: [],
    loading: true,
    hideInvoicesList: false,
    showRemoveButton: false,
    showQrButton: false
  }),
  created() {
    this.reset()
    eventBus.$on('reload', this.reloadRoute)
  },
  beforeDestroy() {
    eventBus.$off('reload', this.reloadRoute)
  },
  computed: {
    filterByQr: {
      get() {
        return this.filter.search_form_po_tag === 'qr'
      },
      set(val) {
        this.filter.search_form_po_tag = val ? 'qr' : null
      }
    },
    emptyFilter() {
      return !this.filter ||
        (!this.filter.search_form_date_orig_date_from &&
          !this.filter.search_form_date_orig_date_to &&
          !this.filter.search_form_name &&
          !this.filter.search_form_po_name &&
          !this.filter.search_form_id &&
          !this.filter.search_form_account_id &&
          !this.filter.order_status)
    }
  },
  methods: {
    reloadRoute(route) {
      if (route === this.$router.currentRoute.name) {
        this.reset()
      }
    },
    reset() {
      this.initData()
      this.loadInvoices()
    },
    initData() {
      this.filter = {
        search_form_distinct_id: '',
        search_form_date_orig_date_from: '',
        search_form_date_orig_date_to: '',
        search_form_name: '',
        search_field_type_name: 'left_like',
        search_form_po_name: '',
        search_field_type_po_name: 'left_like',
        search_form_id: '',
        search_field_type_id: 'direct',
        search_form_account_id: '',
        search_field_type_account_id: 'direct',
        search_form_notes: '',
        search_form_po_tag: null,
        order_status: '',
        submit: 'Поиск',

        order_field: '',
        order_type: ''
      }

      this.pagination = {
        total: 0,
        pageSize: 25,
        currentPage: 0
      }
    },
    parseInvoices(promise) {
      this.loading = true
      this.tableData = []
      promise.then((data) => {
        this.parseInvoicesData(data)
        this.loading = false
      }).catch(() => {
        this.$notify.error({
          title: this.$t('error'),
          message: ''
        })
        this.loading = false
      })
    },
    parseInvoicesData(data) {
      if (data.page_vars) {
        let vars = data.page_vars
        this.showRemoveButton = vars.show_delete
        this.showQrButton = vars.show_qr
        vars.res.records.forEach(r => {
          let payer = []
          if (r.account_first_name && r.account_first_name.length) {
            payer.push(r.account_first_name)
          }
          if (r.account_last_name && r.account_last_name.length) {
            payer.push(r.account_last_name)
          }
          if (!payer.length) {
            payer.push(this.$t('guest'))
          }
          r.payer = payer.join(' ')
          if (r.due_date) {
            r.due_date = new Date(parseInt(r.due_date) * 1000).toLocaleString(this.$locale)
          }
          if (r.date_orig) {
            r.date_orig = new Date(parseInt(r.date_orig) * 1000).toLocaleString(this.$locale)
          }
          r.show = false
        })
        this.tableData = vars.res.records
        this.pagination = {
          total: parseInt(vars.res.results),
          currentPage: parseInt(vars.res.cpage),
          pageSize: parseInt(vars.res.limit)
        }

        if (!this.pageLinks) this.pageLinks = {}
        if (vars.paginator) {
          if (vars.paginator.end_pages) {
            Object.keys(vars.paginator.end_pages).forEach(k => {
              this.pageLinks[k] = vars.paginator.end_pages[k]
            })
          }
          if (vars.paginator.pre_pages) {
            Object.keys(vars.paginator.pre_pages).forEach(k => {
              this.pageLinks[k] = vars.paginator.pre_pages[k]
            })
          }
          if (vars.paginator.next_pages) {
            Object.keys(vars.paginator.next_pages).forEach(k => {
              this.pageLinks[k] = vars.paginator.next_pages[k]
            })
          }
        }

        this.filter.order_field = vars.res.order
        this.filter.order_type = vars.res.sort
        this.sortLinks = vars.order_data
      } else {
        this.tableData = []
        this.pagination = {}
      }
    },
    loadInvoices() {
      window.scroll(0, 0)
      if (apiRes.invoicesUrl) {
        this.parseInvoices(apiRes.post(apiRes.invoicesUrl, this.filter, true).then(url => {
          this.invoicesListUrl = url
          return apiRes.get(url)
        }))
      } else {
        this.loading = false
        this.hideInvoicesList = true
      }
    },
    changePage(newPage) {
      if (this.pageLinks[newPage]) {
        this.parseInvoices(apiRes.get(this.pageLinks[newPage]))
      }
    },
    changeSort(name) {
      if (this.filter.order_field === name) {
        this.filter.order_type = this.filter.order_type === 'asc' ? 'desc' : 'asc'
      } else {
        this.filter.order_field = name
        this.filter.order_type = 'asc'
      }

      this.loadInvoices()
      // if (this.sortLinks[name]) {
      //   this.parseInvoices(apiRes.get(this.sortLinks[name]))
      // }
    },
    newInvoice() {
      this.showInvoiceModal = true
    },
    invoiceChanged(res, invoiceId) {
      this.parseInvoicesData(res)
      if (invoiceId) {
        let invoice = this.tableData.find(invoice => invoice.id === invoiceId)
        if (invoice) {
          this.$nextTick(() => {
            invoice.show = true
          })
        }
      }
    }
  }
}
</script>

<style>
.invoice_amount span,
.item_invoice_card span {
  font-size: 14px;
}

.invoice_status {
  font-size: 16px;
  background-position: left;
  background-size: 36px 36px;
  background-repeat: no-repeat;
  width: 150px;
  height: 36px;
  padding-left: 36px;
  padding-top: 10px;
}

.invoice_status.refunded,
.invoice_status.notpaid,
.invoice_status.overdue,
.invoice_status.declined,
.invoice_status.voided,
.invoice_status.failed {
  color: #fe9292 !important;
  background-image: url(img/invoice-err.svg);
  margin-top: 5px;
}

.invoice_status.due {
  color: #24a9e1 !important;
  background-image: url(img/invoice-due.svg);
  padding-top: 0px;
  margin-top: 5px;
}

.invoice_status.authorized,
.invoice_status.partial_refunded,
.invoice_status.pending,
.invoice_status.blocked {
  color: #e8aa3c !important;
  background-image: url(img/invoice-pending.svg);
  padding-top: 0px;
  margin-top: 5px;
}

.invoice_status.partial_voided,
.invoice_status.recurrent,
.invoice_status.paid,
.invoice_status.oct,
.invoice_status.verification {
  color: #70ac6c !important;
  background-image: url(img/invoice-ok.svg);
  margin-top: 5px;
}

@media only screen and (max-device-width: 823px) {
  .invoice_status {
    width: 100px;
  }
}
</style>
